export default __webpack_public_path__ + "static/media/successImage.5e7bbd37.png";